// =============================================================================
//  SOURCE UNIQUE DE L'URL DE L'API
//  Pour changer d'adresse / de port (localhost, ngrok, serveur de prod),
//  modifie UNIQUEMENT la variable REACT_APP_API_URL dans le fichier .env
//  (a la racine du frontend), puis relance `npm start` (ou `npm run build`).
//
//  Exemple .env :
//      REACT_APP_API_URL=http://localhost:8000/api
//      # ou     REACT_APP_API_URL=https://mon-domaine.com/api
//
//  (Rappel CRA : la valeur est figee au build -> apres modif, on rebuild.)
// =============================================================================

// URL brute issue du .env (repli localhost si absente). trim() enleve un
// eventuel retour chariot Windows en fin de ligne.
const RAW = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').trim();

// .../api  -> base des routes API (sans slash final)
export const API_BASE = RAW.replace(/\/+$/, '');

// racine du serveur SANS /api  -> ex. pour les fichiers /uploads/...
export const API_ROOT = API_BASE.replace(/\/api\/?$/, '');

// .../api/fichier  -> prefixe utilise par plusieurs reducers
export const FICHIER_BASE = API_BASE + '/fichier';

export default API_BASE;
